
const boxIconDefault = document.querySelector(".wishlist-page");
const elementIconLoad = document.createElement("div");
const boxElementIconLoad = document.createElement("div");
if(boxElementIconLoad){
    boxElementIconLoad.classList.add("whishlist-loading");
}
if(elementIconLoad){
    elementIconLoad.classList.add("box-whishlist-loading", "tw-flex", "tw-justify-center", "tw-items-center", "tw-h-full");
}
if(elementIconLoad){
    elementIconLoad.appendChild(boxElementIconLoad);
}
if(boxIconDefault){
    boxIconDefault.appendChild(elementIconLoad);
}
function btnToggleLayout() {
    const btnToggle = document.querySelector('.btn-change-layout-mb');
    btnToggle.classList.toggle('layout-full-width');
}

function checkElements() {
    const productItems = document.querySelectorAll('.wishlist-column');
  
    productItems.forEach((productItem, index) => {
      if (!productItem.classList.contains('loaded')) {
        productItem.classList.add('loaded');
        const productUrl = productItem.querySelector('.wihslist-meta h3 a').getAttribute('href');
        
        fetch(productUrl)
        .then(response => response.text())
        .then(data => {
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(data, 'text/html');
            const productcolor = htmlDocument.querySelector('.product-color-cs');            

            if (productcolor) {
                const colorElement = document.createElement('span');
                colorElement.className = 'color !tw-font-Avenregular tw-mt-[2px] tab:tw-block tw-hidden tab:tw-text-[13px] tw-text-[9px] tw-not-italic tw-font-normal tab:tw-leading-[18px] tw-leading-[18px] tab:tw-tracking-[1.3px] tw-tracking-[0.9px]';
                colorElement.textContent = productcolor.innerText;

                const whProMetaH3 = productItem.querySelector('.wihslist-meta h3');
                whProMetaH3.appendChild(colorElement);
            }
        })
        .catch(error => {
            console.error(error);
        });
        const productDivs = document.querySelector('.wishlist-page');
        productDivs.style.display = '';
      }
    });

}

const intervalId = setInterval(checkElements, 1000);
